import { useLayoutEffect, useRef } from "react"

import { SAudioContainer, SCoverImage } from "./styles"


export const AudioViewer = ({ onCanPlay, onError, src, coverImageUrl = '' }) => {
  const audioRef = useRef(null)

  useLayoutEffect(() => {
    audioRef.current.src = src


    return () => {
      audioRef.current.src = ''
    }
  }, [src])

  return (
    <SAudioContainer>
      {coverImageUrl && <SCoverImage src={coverImageUrl} />}

      <audio
        onCanPlay={onCanPlay}
        onError={onError}
        controls
        preload="auto"
        ref={audioRef}
      />
    </SAudioContainer>
  )
}